import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function Favorites() {
  return (
    <div className="min-h-screen bg-gray-50 py-24 flex items-center justify-center">
      <div className="text-center">
        <Heart className="w-24 h-24 text-gray-300 mx-auto mb-6" />
        <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          Избранное пусто
        </h2>
        <p className="text-gray-600 mb-8">Добавьте товары в избранное</p>
        <Link to="/catalog">
          <Button className="bg-sky-600 hover:bg-sky-700 text-white">
            Перейти в каталог
          </Button>
        </Link>
      </div>
    </div>
  );
}